import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-mark.css';
import { EGDSMarkSize } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSMark = props => {
  const {
    className,
    url,
    description,
    id,
    name,
    size,
    title,
    shadow,
    orientation,
    lazyLoading
  } = props;
  const assetsBaseUrl = 'https://a.travel-assets.com/egds/marks/';
  const svgName = `${name}.svg`;
  const baseCssClass = 'uitk-mark';
  if (!name && !url) {
    console.error(`Uitk-Mark must have "name" or "url" prop`);
  }
  if (title || shadow) {
    console.error(`The following props have been deprecated from Uitk-Mark: "title", "shadow"`);
  }
  const cssClassNames = getClassNameList(baseCssClass, className, {
    [`${baseCssClass}-${orientation}-oriented`]: orientation
  });
  const markCustomProps = {
    [`--uitk-mark-token-size`]: `var(--mark-size-${size})`
  };
  const buildUrl = () => {
    if (url) {
      return url;
    }
    return `${assetsBaseUrl}${svgName}`;
  };
  const alt = description || '';
  return jsx("img", {
    className: cssClassNames,
    alt: alt,
    src: buildUrl(),
    style: markCustomProps,
    id: id,
    loading: lazyLoading === 'off' ? undefined : lazyLoading
  });
};
EGDSMark.defaultProps = {
  orientation: 'landscape',
  size: EGDSMarkSize.MEDIUM
};
EGDSMark.displayName = 'EGDSMark';
export { EGDSMark };